import { TFilterColumns } from "../hooks/useOrderColumn";
import { ShippingMethod } from "../interfaces";

/**
 * SUPPORT
 * isEditable = status, printManufacturer, deliveryDate, internalNote, manufacturerNote
 * isToolTip = internalNote, manufacturerNote, lastOpened
 */

export const DASHBOARD_COLUMNS: TFilterColumns[] = [
  { accessor: "id" },
  { accessor: "status", isEditable: false },
  { accessor: "printManufacturer", isEditable: false },
  { accessor: "deliveryDate", isEditable: false },
  { accessor: "createdAt" },
  { accessor: "uploadedDate" },
  { accessor: "shippingMethod" },
  { accessor: "productType" },
  {
    accessor: "internalNote",
    isEditable: true,
    isTooltip: true,
  },
  {
    accessor: "manufacturerNote",
    isEditable: true,
    isTooltip: true,
  },
  {
    accessor: "viewOrder",
    isTooltip: true,
  },
];

export const ADMIN_DASHBOARD_COLUMNS: TFilterColumns[] = [
  ...DASHBOARD_COLUMNS,
  {
    accessor: "lastOpened",
    isTooltip: true,
  },
];

export const SHIPPING_METHOD_OPTIONS = [
  { key: ShippingMethod.Express, value: "Express" },
  { key: ShippingMethod.Standard, value: "Standard" },
];
